import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';
import { chartColors } from 'src/shared/constants/portfolio';

type Props = {
    value: number;
    startLabel: React.ReactNode;
    endLabel: React.ReactNode;
    color: 'red' | 'orange' | 'green';
    category: string;
};

const GaugeChart = ({ value, startLabel, endLabel, color, category }: Props) => {
    const gaugeData = [
        { name: 'value', value: value, color: chartColors[color] },
        { name: 'remaining', value: 1 - value, color: '#E5E7EB' },
    ];

    return (
        <div className='flex gap-4'>
            <div>
                <div className='flex flex-col gap-1'>
                    <div className='flex items-end mb-1'>
                        <div className='text-xs text-grey-80 text-right'>{startLabel}</div>
                        <div className='relative h-[80px] w-[160px]'>
                            <div className={`absolute text-[42px] top-7 w-full text-center text-${color}-100`}>{value.toFixed(2)}</div>
                            <ResponsiveContainer width='100%' height='100%'>
                                <PieChart>
                                    <Pie
                                        data={gaugeData}
                                        cx='50%'
                                        cy='100%'
                                        startAngle={180}
                                        endAngle={0}
                                        innerRadius={58}
                                        outerRadius={75}
                                        dataKey='value'
                                    >
                                        {gaugeData.map((entry, index) => (
                                            <Cell key={`cell-${index}`} fill={entry.color} />
                                        ))}
                                    </Pie>
                                </PieChart>
                            </ResponsiveContainer>
                        </div>
                        <div className='text-xs text-grey-80'>{endLabel}</div>
                    </div>
                </div>
                <div className={`text-2xl text-center text-${color}-100`}>{category}</div>
            </div>
        </div>
    );
};

export default GaugeChart;
